export const TEACHER_SERVICE = "/teacher-info-sb/v0";

export const TEACHER_SECTIONS_BY_USERNAME = `${TEACHER_SERVICE}/sections/by_username`; // /{teacherUsername}/index.json
export const ROSTER_BY_SECTION = `${TEACHER_SERVICE}/roster/by_section_id`; // /{sectionId}/index.json
